import Vue from "vue";

export default {
  namespaced: true,

  state: {
    promosList: [],
    isEdit: false,
    editPromoItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    promosList(state) {
      return state.promosList
    },
    isEdit(state) {
      return state.isEdit
    },
    editPromoItem(state) {
      return state.editPromoItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_PROMOS(state, promosList) {
      state.promosList = promosList
    },
    SET_PROMO(state, promoItem) {
      state.promosList.push(promoItem)
    },
    REPLACE_PROMO(state, promoItem) {
      let editItemIndex = state.promosList.map(function(item) { return item.id; }).indexOf(promoItem.id);
      Vue.set(state.promosList, editItemIndex, promoItem)
    },
    GET_PROMO(state, index) {
      let editItemIndex = state.promosList.map(function(item) { return item.id; }).indexOf(index);
      state.editPromoItem = state.promosList[editItemIndex]
    },
    SET_FORM_STATUS(state, status) {
      state.isEdit = status
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.promosList.map(function(item) { return item.id; }).indexOf(index);
      state.promosList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
